export function Donut({
  value,
  size = 116,
  label,
}: {
  value: number;
  size?: number;
  label?: string;
}) {
  const clamped = Math.min(100, Math.max(0, value));
  const stroke = 11;
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference * (1 - clamped / 100);

  return (
    <div
      className="donut"
      style={{ width: size, height: size }}
      role="img"
      aria-label={`${label ?? 'Cumplimiento'} ${clamped}%`}
    >
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <title>{`${label ?? 'Cumplimiento'}: ${clamped}%`}</title>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="var(--chart-grid)"
          strokeWidth={stroke}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="var(--chart-line)"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          className="donut__progress"
        />
      </svg>
      <span className="donut__value">{clamped}%</span>
    </div>
  );
}
